import Request from '@/plugins/request'

export function getWarehouses(params) {
  return Request.get('warehouses', { params })
}

export function createWarehouse() {
  return Request.get(`warehouses/create`)
}

export function storeWarehouse(data) {
  return Request.post('warehouses', data)
}

export function updateWarehouse(id, data) {
  return Request.put(`warehouses/${id}`, data)
}

export function editWarehouse(id) {
  return Request.get(`warehouses/${id}/edit`)
}

export function destroyWarehouse(id) {
  return Request.delete(`warehouses/${id}`)
}

// 仓库下拉列表
export function warehouseList() {
  return Request.get(`warehouses/list`)
}
